import { apiRequest } from '@/lib/api-client';
import { JobStatus } from './storyApi';

export const jobsApi = {
  async getJobStatus(jobId: number): Promise<JobStatus> {
    return apiRequest<JobStatus>(
      `/jobs/${jobId}`,
      {},
      'Failed to fetch job status'
    );
  },

  async listJobs(params?: {
    job_type?: string;
    status?: string;
    limit?: number;
  }): Promise<JobStatus[]> {
    const queryParams = new URLSearchParams();
    if (params?.job_type) queryParams.append('job_type', params.job_type);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.limit) queryParams.append('limit', params.limit.toString());

    const queryString = queryParams.toString();
    const url = queryString ? `/jobs?${queryString}` : '/jobs';

    return apiRequest<JobStatus[]>(url, {}, 'Failed to fetch jobs');
  },
};
